"use strict";

var _interopRequireDefault = require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.deleteMessagePlan = deleteMessagePlan;
exports.listMessagePlan = listMessagePlan;
exports.listMessageRecord = listMessageRecord;
exports.repeatMessageRecord = repeatMessageRecord;
exports.saveMessagePlan = saveMessagePlan;
var _request = _interopRequireDefault(require("@/utils/request"));
function saveMessagePlan(data) {
  return (0, _request.default)({
    url: '/portal/system/message/saveMessagePlan',
    method: 'post',
    data: data
  });
}
function listMessagePlan(data) {
  return (0, _request.default)({
    url: '/portal/system/message/listMessagePlan',
    method: 'post',
    data: data
  });
}
function deleteMessagePlan(data) {
  return (0, _request.default)({
    url: '/portal/system/message/deleteMessagePlan',
    method: 'post',
    data: data
  });
}
function listMessageRecord(data) {
  return (0, _request.default)({
    url: '/portal/system/message/listMessageRecord',
    method: 'post',
    data: data
  });
}
function repeatMessageRecord(data) {
  return (0, _request.default)({
    url: '/portal/system/message/repeatMessageRecord',
    method: 'post',
    data: data
  });
}